import { create } from 'zustand';

import type {
  PerformanceDebugLog,
  PerformanceDebugLogPayload,
  PerformanceDebugLogType,
} from './performanceDebugLogStore.types';

const maxLogCapacity = 400;

interface PerformanceDebugLogs {
  readonly isLoggingEnabled: boolean;
  readonly debugLogs: PerformanceDebugLog[];
}

const usePerformanceDebugLogStore = create<PerformanceDebugLogs>(() => ({
  isLoggingEnabled: false,
  debugLogs: [],
}));

type SetPerformanceLoggingEnabled = (isEnabled: boolean) => void;
export const setPerformanceLoggingEnabled: SetPerformanceLoggingEnabled = (isEnabled) => {
  usePerformanceDebugLogStore.setState({ isLoggingEnabled: isEnabled });
};

type AddPerfDebugLog = (
  debugLogs: PerformanceDebugLog[],
  payload: PerformanceDebugLogPayload,
  type: PerformanceDebugLogType
) => PerformanceDebugLog[];
const addPerfDebugLog: AddPerfDebugLog = (debugLogs, payload, type) => {
  const perfLogs = debugLogs.length >= maxLogCapacity ? debugLogs.slice(1) : debugLogs;

  return [
    ...perfLogs,
    {
      id: `${payload.name}_${new Date().getTime()}`,
      type,
      payload,
    },
  ];
};

type LogComponentPerformance = (payload: PerformanceDebugLogPayload) => void;
export const logComponentPerformance: LogComponentPerformance = (payload) => {
  if (!usePerformanceDebugLogStore.getState().isLoggingEnabled) {
    return;
  }

  usePerformanceDebugLogStore.setState((state) => ({
    debugLogs: addPerfDebugLog(state.debugLogs, payload, 'Component'),
  }));
};

type LogApiPerformance = (payload: PerformanceDebugLogPayload) => void;
export const logApiPerformance: LogApiPerformance = (payload) => {
  if (!usePerformanceDebugLogStore.getState().isLoggingEnabled) {
    return;
  }

  usePerformanceDebugLogStore.setState((state) => ({
    debugLogs: addPerfDebugLog(state.debugLogs, payload, 'Api'),
  }));
};

type ClearPerformanceLogs = () => void;
export const clearPerformanceLogs: ClearPerformanceLogs = () => {
  usePerformanceDebugLogStore.setState({ debugLogs: [] });
};

type UseGetPerfDebugLogs = () => PerformanceDebugLog[];
export const useGetPerfDebugLogs: UseGetPerfDebugLogs = () => usePerformanceDebugLogStore((state) => state.debugLogs);
